module.exports = __webpack_public_path__ + "img/bo.028edd26.svg";